var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Injectable } from '@angular/core';
import { Point } from './point';
var PointService = /** @class */ (function () {
    function PointService() {
        this.separator = ' ';
    }
    PointService.prototype.parse = function (pointString, separator) {
        if (separator === void 0) { separator = this.separator; }
        if (pointString) {
            var stringArray = pointString.split(separator);
            if (stringArray.length === 2) {
                return new Point(+stringArray[0], +stringArray[1]);
            }
        }
        return undefined;
    };
    PointService = __decorate([
        Injectable()
    ], PointService);
    return PointService;
}());
export { PointService };
